import React from 'react';
import NavBar from '../components/NavBar';
import ScrollBackground from '../components/ScrollBackground';
import Hero from '../components/Hero';
import WhatWeDo from '../components/WhatWeDo';
import CoreThesis from '../components/CoreThesis';
import TransactionArchitecture from '../components/TransactionArchitecture';
import StrategicPhilosophy from '../components/StrategicPhilosophy';
import Founder from '../components/Founder';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <>
      {/* Fixed background that transitions through time of day on scroll */}
      <ScrollBackground />

      {/* All content scrolls over the fixed background */}
      <div className="relative z-10">
        <NavBar />
        <Hero />
        <WhatWeDo />
        <CoreThesis />
        <TransactionArchitecture />
        <StrategicPhilosophy />
        <Founder />
        <Footer />
      </div>
    </>
  );
};

export default Home;
